// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--2fuD-";
export var backgroundMedia = "hero-module--backgroundMedia--14uUW";
export var graphic = "hero-module--graphic--aov5C";